import { render } from "@/components/pages/attentionRepro/AttentionRepro.html?vue&type=template&id=adcba7cc&external"
import script from "@/components/pages/attentionRepro/AttentionRepro.js?vue&type=script&lang=js&external"
export * from "@/components/pages/attentionRepro/AttentionRepro.js?vue&type=script&lang=js&external"

import "@/components/pages/attentionRepro/AttentionRepro.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__